/** Help text for case sheets. */

const caseSheet = {
  target_id: "The target this case sheet is recorded against. It decides which incentive configuration the cases count towards.",
  employment_id: "Employee whose cases are being recorded. Their achieved cases are compared with the monthly target to work out incentive.",
  date: "Date the cases were completed on.",
  cases: "The cases completed. Cases beyond the monthly target earn at the overtime case rate, if the target scheme allows it.",
};

export const taskTooltips = { caseSheet };
export default taskTooltips;
